import { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb'
import { getAllCBTAttempt } from '../../../api/courses'
import StudentSidebar from '../common/studentSidebar'
import { all_routes } from '../../router/all_routes'

interface CbtCourseResponse {
  title: string,
  min_passing_score: string,
  questions: any[]
}

interface CbtAnswerListResponse {
  attempt_id: string;
  user_name: string;
  email: string;
  phone_number: string;
  attempt_start_at: string;
  attempt_end_at: string;
  jumlah_benar: number;
  jumlah_salah: number;
  score: number;
}

const CBTUserList = () => {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate();

  // API data states
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [course, setCourse] = useState<CbtCourseResponse>(null);
  const [answerList, setAnswerList] = useState<CbtAnswerListResponse[]>([]);

  // Fetch CBT data from API
  useEffect(() => {
    const fetchCBTData = async () => {
      if (!id) {
        setError('Course ID not found')
        setLoading(false)
        return
      }

      try {
        setLoading(true)

        const res = await getAllCBTAttempt(id)
        setCourse(res?.course);
        setAnswerList(res?.data);

      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load CBT data')

        setTimeout(() => {
          navigate(-1);
        }, 1000);
      } finally {
        setLoading(false)
      }
    }

    fetchCBTData()
  }, [id, navigate])

  const handleSeeReview = (attempt_id: string) => {
    navigate(all_routes.studentCBTReview.replace(':id', attempt_id || ''))
  }

  return (
    <>
      <Breadcrumb title="Review CBT Test" />

      <div className="content">
        <div className="container">
          <div className="row">
            <StudentSidebar />
            <div className="col-lg-9">
              <div className="card">
                <div className="card-body">
                  <h5 className="mb-3 fs-18 border-bottom pb-3">Riwayat Ujian Kamu</h5>
                  <div
                    className="d-flex align-items-center flex-wrap flex-md-nowrap justify-content-between mb-3"
                  >
                    <div className='w-100'>
                      <h6 className="mb-1">{course?.title}</h6>
                      <p className="mb-3">{course?.questions.length} Pertanyaan</p>

                      <div className="table-responsive custom-table">
                        <table className="table">
                          <thead className="thead-light">
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Start Time</th>
                              <th scope="col">End Time</th>
                              <th scope="col">Benar</th>
                              <th scope="col">Salah</th>
                              <th scope="col">Score</th>
                              <th scope="col">Status</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {answerList && answerList.length > 0 ? (
                              answerList.map((attempt, index) => {
                                const isPassed = course?.min_passing_score
                                  ? Number(attempt.score) >= Number(course.min_passing_score)
                                  : false;

                                return (<tr key={attempt.attempt_id}>
                                  <td>{index + 1}</td>
                                  <td>{attempt.attempt_start_at}</td>
                                  <td>{attempt.attempt_end_at}</td>
                                  <td>{attempt.jumlah_benar}</td>
                                  <td>{attempt.jumlah_salah}</td>
                                  <td>
                                    <span className="fw-semibold">{attempt.score}</span>
                                  </td>
                                  <td>
                                    {isPassed ? (
                                      <span className="badge bg-success">Passed</span>
                                    ) : (
                                      <span className="badge bg-danger">Not Passed</span>
                                    )}
                                  </td>
                                  <td>
                                    <button
                                      className="d-inline-flex fs-14 action-icon"
                                      onClick={() => handleSeeReview(attempt.attempt_id)}
                                      title="Review"
                                      style={{
                                        background: 'none',
                                        border: 'none',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <i className="isax isax-eye" />
                                    </button>
                                  </td>
                                </tr>)
                              })
                            ) : (
                              <tr>
                                <td colSpan={6} className="text-center text-muted py-3">
                                  Belum ada riwayat ujian.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .option-circle {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
        }
      `}</style>
    </>
  )
}

export default CBTUserList
